import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { forwardRef } from 'react';
import styles from './style/icon-button.module.less';
import cs from 'classnames';
function IconButton(props, ref) {
  const {
    icon,
    className,
    ...rest
  } = props;
  return /*#__PURE__*/React.createElement(_Button, _extends({
    ref: ref,
    icon: icon,
    shape: "circle",
    type: "secondary",
    className: cs(styles['icon-button'], className)
  }, rest));
}
export default /*#__PURE__*/forwardRef(IconButton);